import { LoadingAnimation, Modal } from '@uag/react-core';
import { useGetRequestDetail } from '@uag/welcome-shared/src/api/queries/requests/requests';
import { useTranslation } from 'react-i18next';
import { create, InstanceProps } from 'react-modal-promise';
import { useParams } from 'react-router';

import { ViewCompany } from 'app/request/ViewCompany';

type Props = {} & InstanceProps<void>;

export const ViewCompanyModal = ({ isOpen, onResolve, onReject }: Props) => {
    const { t } = useTranslation();
    const { requestId = '' } = useParams();
    const { data: apiRequestDetail, isLoading: isRequestDetailLoading } = useGetRequestDetail(requestId);

    const submit = () => onResolve();
    const reject = () => onReject();

    return (
        <Modal className="w-[960px]" opened={isOpen} title={t('viewCompanyData')} onAbort={reject} onClose={submit}>
            {isRequestDetailLoading && <LoadingAnimation />}
            {!isRequestDetailLoading && apiRequestDetail?.data && (
                <ViewCompany request={apiRequestDetail?.data} onClose={submit} />
            )}
        </Modal>
    );
};

export const openViewCompanyModal = create(ViewCompanyModal);
